import {Fragment} from 'react';

import {TaxService as Service} from './TaxService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';
import {useImExExcel} from '../../../shared/hooks/ImExExcel';
import {useTranslation} from '../../../shared/language';

export const List = () => {

  const {t} = useTranslation();
  const header = t('catalog.taxRate');
  const dataKey = 'id';

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems, dataTableParams} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'orders', header: t('common.sequenceNumber'), width: 160, dataType: 'number'},
      {field: 'code', header: t('catalog.taxCode'), width: 200},
      {field: 'name', header: t('common.description'), minWidth: 250},
      {field: 'taxValue', header: t('system.value'), width: 160, dataType: 'number'}
    ],
    actionColumnWidth: 0,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      {field: 'code', header: t('catalog.taxCode'), required: true, uppercase: true, InputTextProps: {maxLength: 11}, className: 'md:col-12'},
      {field: 'name', header: t('common.description'), required: true, InputTextProps: {maxLength: 50}, className: 'md:col-12'},
      {field: 'taxValue', header: t('system.value'), required: true, type: 'InputNumber', InputNumberProps: {min: 0, maxFractionDigits: 2}, className: 'md:col-12'},
      {field: 'orders', header: t('common.sequenceNumber'), type: 'InputNumber', InputNumberProps: {showButtons: true}, className: 'md:col-12'}
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {renderImExExcel, download, showImportDialog} = useImExExcel({
    exportTemplate: () => {
      return Service.downloadExcelTemplate();
    },
    exportExcel: (params) => {
      return Service.downloadExcel(params);
    },
    exportExcelFileName: 'danh-muc-thue-suat',
    importExcel: (data) => {
      return Service.uploadExcel(data);
    },
    reloadLazyData
  });

  const {renderToolbar} = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    showImportDialog,
    exportExcel: download, dataTableParams,
    deleteItem: (id) => {
      return Service.delete(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
      {renderImExExcel()}
    </Fragment>
  )
}
